export const SITE = {
    name: "sthaan",
    domain: "sthaan.space",
    email: "hello@sthaan.space",
    instagram: "https://www.instagram.com/sthaan.space",
    company: "Indexa Distribution Services Pvt. Ltd.",
    cin: "U62099GJ2024PTC152242",
    address:
        "Office No. 16, Ground Floor, Samkeet Arcade, Plot No 64, Sector-8, Gandhidham-370201, Gujarat, India",
};

export const IMG = {
    hero_residential:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85",
    hero_commercial:
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85",
    hero_dusk:
        "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&q=85",
    interior_living_room:
        "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&q=85",
    interior_penthouse:
        "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85",
    interior_lounge:
        "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&q=85",
    pool_infinity:
        "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85",
    clubhouse_spa:
        "https://images.unsplash.com/photo-1540555700478-4be289fbecef?crop=entropy&cs=srgb&fm=jpg&q=85",
    landscape_resort:
        "https://images.unsplash.com/photo-1571896349842-33c89424de2d?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_mumbai:
        "https://images.unsplash.com/photo-1569758267239-d08deb78bb1a?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_bengaluru:
        "https://images.unsplash.com/photo-1588416936097-41850ab3d86d?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_delhi_ncr:
        "https://images.unsplash.com/photo-1688257899811-d96d969416bf?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_hyderabad:
        "https://images.unsplash.com/photo-1741545979534-02f59c742730?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_pune:
        "https://images.unsplash.com/photo-1589629041152-fb71b9c5dbcd?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_ahmedabad:
        "https://images.unsplash.com/photo-1651408451633-ff492f347ec1?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_chennai:
        "https://images.unsplash.com/photo-1616843413587-9e3a37f7bbd8?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_kolkata:
        "https://images.unsplash.com/photo-1651651166379-06540f274707?crop=entropy&cs=srgb&fm=jpg&q=85",
    city_bhuj:
        "https://images.unsplash.com/photo-1620103143245-9efb3e4a7553?crop=entropy&cs=srgb&fm=jpg&q=85",
    interior_bedroom:
        "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?crop=entropy&cs=srgb&fm=jpg&q=85",
    interior_kitchen:
        "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?crop=entropy&cs=srgb&fm=jpg&q=85",
    entrance_lobby:
        "https://images.unsplash.com/photo-1600585152220-90363fe7e115?crop=entropy&cs=srgb&fm=jpg&q=85",
    fitness_gym:
        "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&q=85",
    aerial_site:
        "https://images.unsplash.com/photo-1506974287702-602e4ee1c4d9?crop=entropy&cs=srgb&fm=jpg&q=85",
    balcony_dusk:
        "https://images.unsplash.com/photo-1512915922686-57c11dde9b6b?crop=entropy&cs=srgb&fm=jpg&q=85",
    commercial_office:
        "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85",
    commercial_retail:
        "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?crop=entropy&cs=srgb&fm=jpg&q=85",
    residential_tower:
        "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&q=85",
    villa_exterior:
        "https://images.unsplash.com/photo-1613977257363-707ba9348227?crop=entropy&cs=srgb&fm=jpg&q=85",
    pool_deck:
        "https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?crop=entropy&cs=srgb&fm=jpg&q=85",
    garden_courtyard:
        "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const waLink = (phone, projectName, extra) => {
    const msg =
        extra ||
        `Hi, I found ${projectName} on Sthaan and I'm interested in this property. I would like to know more about availability, configurations and details.`;
    return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
};

export const PROJECT_STATUSES = [
    "Newly Launched",
    "Under Construction",
    "Ready to Move",
];

export const VERIFY_NOTE =
    "Project information on Sthaan is sourced from the respective developers. Please independently verify pricing, availability, specifications, approvals, RERA details and possession timelines directly with the developer before making any decision.";

export const CONTACT_NOTICE =
    "By choosing to contact a developer through Sthaan, you understand that your communication may be shared directly with the respective developer and that the developer may contact you regarding your enquiry.";
